// import Link from 'components/Link'
import { removeStorage ,getStorageParse} from "pages/Utils";
import { Link as Link1, NavLink } from "react-router-dom";

const Link = ({ children, ...props }) => {
  var link_to = props.href;
  delete props.href;
  return (
    <Link1
      // onClick={() => {
      //   if ((props?.remove_storage || false)) {
      //     removeStorage("id_profile");
      //     removeStorage("jenis_param");
      //   }
      // }}
      to={link_to}
      {...props}
    >
      {children}
    </Link1>
  );
};

export default Link;
